import { useEffect, useState, useRef,useCallback } from "react";

import { projects } from "../mockdata";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Loader from "../components/Loader";



export const ProjectDetail = () => {
  const { id } = useParams();
  
  const location = useLocation();
  const galleryRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const project = projects.find((p) => String(p.id) === String(id));
  const bgImage = "/images/projectBackground.webp";

  // const fromFeatured = location.state?.fromFeatured;
  // // const scrollPosition = location.state?.scrollPosition || 0;
  // // const backTo = fromFeatured ? "/" : "/projects";
  // const backLabel = fromFeatured
  //   ? "← Back to Featured Projects"
  //   : "← Back to Projects";

 useEffect(() => {
  // Scroll to gallery only if URL has scroll=video
  const scrollToGallery = () => {
    const searchParams = new URLSearchParams(location.search);
    const scrollTarget = searchParams.get("scroll");

    if (scrollTarget === "video" && galleryRef.current) {
      // Smooth scroll to gallery section
      galleryRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // Call scroll function after small delay to ensure data loads
  const timer = setTimeout(() => {
    setLoading(false); // your existing logic
    scrollToGallery();
  }, 1000); // match your current loader delay

  return () => clearTimeout(timer);
}, [location.search]);

//   const handleBack = () => {
//   // Send back necessary scroll info to ProjectsPage
//   navigate("/projects", {
//     state: {
//       scrollIndex: location.state?.scrollIndex,
//       category: location.state?.category,
//       page: location.state?.page,
//     },
//   });
// };

  if (!project)
    return <div className="p-12 text-center text-xl">Project not found.</div>;
  if (loading) return <Loader />;

 

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center pb-12">
      {/* Header Image with Title */}
      <div className="relative w-full h-80 md:h-[420px] lg:h-[520px] flex items-center justify-center mb-10">
        <img
          src={bgImage}
          alt="bg panoramic"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-white/60" />
        <h1 className="relative z-10 text-3xl md:text-5xl font-extrabold text-gray-900 text-center drop-shadow-lg">
          {project.title}
        </h1>
      </div>

      {/* Project Image */}
      <div className="w-full max-w-3xl flex justify-center mb-8">
        <img
          src={project.image}
          alt={project.title}
          className="w-full max-w-xl h-64 object-contain rounded-xl shadow-lg border border-gray-200 bg-black"
        />
      </div>

      {/* Details Section */}
      <div className="w-full max-w-3xl bg-white rounded-xl shadow p-8 mb-8 flex flex-col gap-4">
        <div className="w-16 h-1 bg-red-600 mx-auto my-2 rounded"></div>
        <div className="text-lg md:text-xl text-gray-800">
          <span className="font-semibold">Client Name:</span>{" "}
          {project.clientName}
        </div>
        <div className="text-lg md:text-xl text-gray-800">
          <span className="font-semibold">Work:</span> {project.work}
        </div>
        <div className="text-lg md:text-xl text-gray-800">
          <span className="font-semibold">Location:</span> {project.location}
        </div>
        <div className="text-lg md:text-xl text-gray-800">
          <span className="font-semibold">Area:</span> {project.area}
        </div>
        <div className="text-lg md:text-xl text-gray-800">
          <span className="font-semibold">Load:</span> {project.load}
        </div>
        {project.description && (
          <div className="text-base md:text-lg text-gray-700 mt-4">
            <span className="font-semibold">Description:</span>{" "}
            {project.description}
          </div>
        )}
      </div>

  {Array.isArray(project.videos) && project.videos.length > 0 && (
  <div ref={galleryRef} id="gallery" className="w-full max-w-5xl px-2 mb-10">
    <h2 className="text-2xl font-bold text-blue-900 mb-4 ml-2">Gallery</h2>

    <div className="flex gap-6 overflow-x-auto scrollbar-thin scrollbar-thumb-blue-200 scrollbar-track-blue-50 pb-2">
      {project.videos.map((vid, idx) => (
        <video
  key={idx}
  src={vid}
  controls
  muted
  loop
  autoPlay={idx === 0} 
  
  playsInline
  className="rounded-lg shadow border border-gray-200 bg-black w-96 h-60 min-w-[384px] object-contain"
  poster={project.image}
/>

      ))}
    </div>
  </div>
)}





      {/* Back Button */}
      {/* <button
        onClick={handleBack}
        className="mt-8 px-8 py-3 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-700 transition w-max shadow-lg"
      >
        {backLabel}
      </button> */}

      
      
    </div>
  );
};


const INITIAL_COUNT = 6;
const LOAD_MORE_COUNT = 6;

const ProjectsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);
  const [activeCategory, setActiveCategory] = useState(() => {
    const saved = sessionStorage.getItem("projectsCurrentCategory");
    return saved || "All";
  });
  const [initialLoading, setInitialLoading] = useState(() => {
  return sessionStorage.getItem("projectsPageVisited") ? false : true;
});


  const [showLoadMoreSpinner, setShowLoadMoreSpinner] = useState(false); // ✅ new state

  const scrollRef = useRef(null);
  const cardsRef = useRef([]);
  const observerRef = useRef(null);
  const loadMoreRef = useRef(null);
  const scrollIndexRef = useRef(null);

  const categories = [
    "All",
    "Commercial",
    "Residential",
    "Healthcare",
    "Educational",
    "Industrial",
    "Hospitality",
    "Small Projects",
  ];

  const filteredProjects =
    activeCategory === "All"
      ? projects
      : projects.filter((proj) => proj.category === activeCategory);

  const currentProjects = filteredProjects.slice(0, visibleCount);

  const handleCardClick = (id, index) => {
    sessionStorage.setItem("projectsCurrentCategory", activeCategory);
    sessionStorage.setItem("projectsScrollIndex", index);
    sessionStorage.setItem("projectsScrollTimestamp", Date.now().toString());
    sessionStorage.setItem("projectsVisibleCount", visibleCount);

    navigate(`/projects/${id}`, {
      state: {
        scrollIndex: index,
        category: activeCategory,
      },
    });
  };

  const handleCategoryClick = (category) => {
    sessionStorage.setItem("projectsCurrentCategory", category);
    sessionStorage.setItem("projectsVisibleCount", INITIAL_COUNT);

    setActiveCategory(category);
    setVisibleCount(INITIAL_COUNT);
  };

  // ✅ Show spinner for 1s then load more projects
  const loadMoreProjects = useCallback(() => {
  if (showLoadMoreSpinner) return;

  setShowLoadMoreSpinner(true);

  setTimeout(() => {
    setVisibleCount((prev) =>
      Math.min(prev + LOAD_MORE_COUNT, filteredProjects.length)
    );
    setShowLoadMoreSpinner(false);
  }, 1000);
}, [showLoadMoreSpinner, filteredProjects.length]);

const handleObserver = useCallback(
  (entries) => {
    const target = entries[0];
    if (target.isIntersecting) {
      loadMoreProjects();
    }
  },
  [loadMoreProjects]
);

useEffect(() => {
  if (observerRef.current) observerRef.current.disconnect();
  observerRef.current = new IntersectionObserver(handleObserver);
  if (loadMoreRef.current) observerRef.current.observe(loadMoreRef.current);

  return () => {
    if (observerRef.current) observerRef.current.disconnect();
  };
}, [handleObserver]);


  useEffect(() => {
    const scrollIndex = location.state?.scrollIndex;
    const category = location.state?.category;
    const savedScrollIndex = Number(
      sessionStorage.getItem("projectsScrollIndex")
    );
    const savedTimestamp = Number(
      sessionStorage.getItem("projectsScrollTimestamp")
    );
    const now = Date.now();
    const maxDelay = 5000;

    const shouldRestore =
      typeof scrollIndex === "number" ||
      (now - savedTimestamp < maxDelay &&
        !scrollIndex &&
        savedScrollIndex >= 0);

    if (shouldRestore) {
      const finalScrollIndex = scrollIndex ?? savedScrollIndex;
      const savedVisibleCount =
        Number(sessionStorage.getItem("projectsVisibleCount")) || INITIAL_COUNT;
      const finalCategory =
        category ?? sessionStorage.getItem("projectsCurrentCategory");

      if (finalCategory) {
        setActiveCategory(finalCategory);
      }

      scrollIndexRef.current = finalScrollIndex;

      if (
        typeof finalScrollIndex === "number" &&
        finalScrollIndex >= 0
      ) {
        setVisibleCount(Math.max(savedVisibleCount, finalScrollIndex + 1));
      }
    } else {
      sessionStorage.removeItem("projectsScrollIndex");
      sessionStorage.removeItem("projectsScrollTimestamp");
      sessionStorage.removeItem("projectsVisibleCount");
      sessionStorage.removeItem("projectsCurrentCategory");
    }
  }, [location.state]);

  // ⬇️ Scroll to card
  useEffect(() => {
    const index = scrollIndexRef.current;
    if (typeof index === "number" && cardsRef.current[index]) {
      setTimeout(() => {
        cardsRef.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
      scrollIndexRef.current = null;
    }
  }, [visibleCount, activeCategory]);

 useEffect(() => {
  if (initialLoading) {
    const timer = setTimeout(() => {
      setInitialLoading(false);
      sessionStorage.setItem("projectsPageVisited", "true");
    }, 1000); // 1 second loader
    return () => clearTimeout(timer);
  }
}, [initialLoading]);


//   if (initialLoading) {
//   return (
//     <div className="flex justify-center items-center min-h-screen bg-white">
//       <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin" />
//       <span className="ml-3 text-gray-700 text-sm">Loading projects...</span>
//     </div>
//   );
// }


  return (
    <div>
      {/* Hero */}
      <div className="relative w-full h-64 sm:h-80 md:h-[420px] lg:h-[520px] flex items-center justify-center overflow-hidden mb-0 rounded-none">
        <img
          src="/images/projectBg.webp"
          alt="Clients panoramic"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-white/60" />
        <h1 className="relative z-10 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 text-center drop-shadow-lg px-4">
          All Clients
        </h1>
      </div>

      {/* Projects Section */}
      <div className="min-h-screen pb-5 px-8 sm:px-6 bg-slate-100">
        <Helmet>
          <title>Projects | Milestone Associates</title>
        </Helmet>

        {/* Category Filter */}
        <div
          ref={scrollRef}
          className="flex flex-wrap justify-center gap-3 py-8 px-4"
        >
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => handleCategoryClick(cat)}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition ${
                activeCategory === cat
                  ? "bg-blue-900 text-white"
                  : "bg-gray-200 hover:bg-gray-300 text-gray-700"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Project Cards */}
        {initialLoading ? (
  <div className="flex justify-center items-center py-24">
    <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin" />
    <span className="ml-3 text-gray-700 text-sm">Loading projects...</span>
  </div>
) : (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
    {currentProjects.map((project, index) => (
      <div
        key={project.id}
        ref={(el) => (cardsRef.current[index] = el)}
        onClick={() => handleCardClick(project.id, index)}
        className="project-card bg-white rounded-xl border border-gray-200 overflow-hidden cursor-pointer transition duration-300 transform hover:scale-105 hover:shadow-xl hover:border-blue-700"
      >
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-52 object-cover"
        />
        <div className="p-5">
          <h2 className="text-xl font-semibold text-gray-800 mb-1">
            {project.title}
          </h2>
          <p className="text-gray-600">{project.location}</p>
        </div>
      </div>
    ))}
  </div>
)}


        {/* Spinner */}
        {showLoadMoreSpinner && (
          <div className="flex justify-center py-8">
            <div className="w-5 h-5 border-2 border-gray-300 border-t-gray-700 rounded-full animate-spin" />
            <span className="ml-2 text-sm text-gray-600">Loading more projects...</span>
          </div>
        )}

        {/* Infinite Scroll Trigger */}
        {visibleCount < filteredProjects.length && (
          <div
            ref={loadMoreRef}
            className="py-10 flex justify-center text-gray-500"
          >
            {/* Nothing here; just the observer anchor */}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsPage;
